import type { SalesTransaction } from '../types/salesTransaction';

export const salesTransactionRowKey = (txn: SalesTransaction): string =>
  `${txn.transaction_type}-${txn.id}`;

export interface SalesTransactionTotals {
  count: number;
  totalAmount: number;
  balance: number;
}

export const computeSalesTransactionTotals = (
  rows: SalesTransaction[]
): SalesTransactionTotals => {
  let totalAmount = 0;
  let balance = 0;
  for (const txn of rows) {
    totalAmount += parseFloat(txn.total_amount) || 0;
    if (txn.transaction_type !== 'QUOTATION') {
      balance += parseFloat(txn.balance) || 0;
    }
  }
  return {
    count: rows.length,
    totalAmount,
    balance,
  };
};
